import createVueComponent from '../createVueComponent';

const MoveUpLeft = createVueComponent('MoveUpLeftIcon', [
  ['path', { d: 'M5 11V5H11', key: '3q78g9' }],
  ['path', { d: 'M5 5L19 19', key: '5zm2fv' }],
]);

export default MoveUpLeft;
